import { useCallback, useState } from 'react'
import {
  personalAchievementsSelectors,
  personalAchievementsThunks,
} from '@ucheba/store/personalAchievements'
import { examsSelectors, examsThunks } from '@ucheba/store/exams'
import { useDispatch, useSelector } from 'react-redux'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { useRouter } from 'next/router'

interface IUseLayoutInstitutionCore {
  (): {
    restartAssessmentOfChances: () => void
    setOpenSelectEge: (open: boolean | ((prevValue: boolean) => boolean)) => void
    setOpenResultsAssessmentOfChances: (
      open: boolean | ((prevValue: boolean) => boolean)
    ) => void
    handleToggleSelectEge: () => void
    openSelectEge: boolean
    openResultsAssessmentOfChances: boolean
  }
}

export const useLayoutInstitutionCore: IUseLayoutInstitutionCore = () => {
  const achievements = useSelector(personalAchievementsSelectors.selectAll)
  const exam = useSelector(examsSelectors.selectAll)
  const dispatch = useDispatch()
  const { query, replace, asPath } = useRouter()

  const [openResultsAssessmentOfChances, setOpenResultsAssessmentOfChances] =
    useState(false)

  const [openSelectEge, setOpenSelectEge] = useState(false)

  const restartAssessmentOfChances = useCallback(() => {
    setOpenResultsAssessmentOfChances(false)
    setOpenSelectEge(true)
    if (!exam.length) {
      dispatch(examsThunks.fetch({}))
    }
  }, [exam.length])

  const handleToggleSelectEge = useCallback(() => {
    if (query.showOddsStep1) {
      replace(
        stringifyUrl(asPath, {
          exclude: ['showOddsStep1'],
        }),
        undefined,
        {
          shallow: true,
        }
      )
    }

    setOpenSelectEge((prevValue) => !prevValue)
    if (!exam.length) {
      dispatch(examsThunks.fetch({}))
    }
  }, [asPath, dispatch, exam.length, query.showOddsStep1, replace])

  return {
    restartAssessmentOfChances,
    setOpenSelectEge,
    setOpenResultsAssessmentOfChances,
    openResultsAssessmentOfChances,
    openSelectEge,
    handleToggleSelectEge,
  }
}
